import { useState } from 'react';
import { Box, Grid, InputLabel, TextField, Typography, Popover, Button, Checkbox, FormControlLabel } from '@mui/material';
import CreateIcon from '@mui/icons-material/Create';
import VpnKeyIcon from '@mui/icons-material/VpnKey';
import { Formik, Form, Field } from 'formik';

interface InputFieldProps {
  values: any;
  index: number;
  childIndex: number;
  setFieldValue: (key: string, value: any) => void;
  onSubmit: (data: any) => void;
  handleChange: (data: any) => void;
  handleBlur: (data: any) => void;
}

export default function InputField({ values, setFieldValue, index, onSubmit, handleChange, handleBlur, childIndex }: InputFieldProps) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleEditClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClosePopover = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'edit-label-popover' : undefined;

  const child = values.fields[index].children[childIndex];
  console.log(values.fields[index].children[childIndex], 'child');

  return (
    <Box sx={{ width: '100%' }}>
      <Grid container alignItems="center" spacing={1}>
        <Grid item xs={12} display="flex" alignItems="center" gap={1}>
          <InputLabel sx={{ color: 'black' }}>{child.question}</InputLabel>
          {child.isAuthKey && <VpnKeyIcon fontSize="small" color="warning" />}
        </Grid>

        <Grid item xs={11}>
          <TextField fullWidth value="" onChange={handleChange} onBlur={handleBlur} name={`child.question`} disabled />
        </Grid>

        <Grid item xs={1}>
          <Box sx={{ cursor: 'pointer', color: 'primary.main' }} onClick={handleEditClick}>
            <CreateIcon fontSize="medium" />
          </Box>
        </Grid>
      </Grid>

      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClosePopover}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        PaperProps={{ sx: { width: 350, p: 2 } }}
      >
        <Formik
          initialValues={{
            label: child.question || '',
            entries: [],
            isSupportFileRequired: child.settings?.isSupportFileRequired || false,
            noOfSupportImages: child.settings?.noOfSupportImages || '',
            isAuthKey: child.settings?.isAuthKey || false,
            required: child.settings?.required || false,
            min: child.settings?.min || '',
            max: child.settings?.max || '',
            regexp: child.settings?.regexp || '',
            description: child.description || ''
          }}
          enableReinitialize
          onSubmit={(formValues) => {
            setFieldValue(`fields.${index}.children.${childIndex}.question`, formValues.label);
            setFieldValue(`fields.${index}.children.${childIndex}.description`, formValues.description);
            setFieldValue(`fields.${index}.children.${childIndex}.settings.isSupportFileRequired`, formValues.isSupportFileRequired);
            setFieldValue(
              `fields.${index}.children.${childIndex}.settings.noOfSupportImages`,
              formValues.isSupportFileRequired ? formValues.noOfSupportImages : ''
            );
            setFieldValue(`fields.${index}.children.${childIndex}.settings.isAuthKey`, formValues.isAuthKey);
            setFieldValue(`fields.${index}.children.${childIndex}.settings.required`, formValues.required);
            setFieldValue(`fields.${index}.children.${childIndex}.settings.min`, formValues.min);
            setFieldValue(`fields.${index}.children.${childIndex}.settings.max`, formValues.max);
            setFieldValue(`fields.${index}.children.${childIndex}.settings.regexp`, formValues.regexp);
            handleClosePopover();
          }}
        >
          {({ values: formValues, handleChange, handleBlur, setFieldValue }) => (
            <Form>
              <Typography variant="subtitle1" mb={2}>
                Edit Field Settings
              </Typography>

              <Grid container spacing={2}>
                <Grid item xs={4}>
                  <InputLabel>Label</InputLabel>
                </Grid>
                <Grid item xs={8}>
                  <Field as={TextField} name="label" fullWidth size="small" onChange={handleChange} onBlur={handleBlur} />
                </Grid>

                <Grid item xs={4}>
                  <InputLabel>Description</InputLabel>
                </Grid>
                <Grid item xs={8}>
                  <Field as={TextField} name="description" fullWidth size="small" onChange={handleChange} onBlur={handleBlur} />
                </Grid>

                <Grid item xs={4}>
                  <InputLabel>Min-Length</InputLabel>
                </Grid>
                <Grid item xs={8}>
                  <Field as={TextField} name="min" type="number" fullWidth size="small" />
                </Grid>

                <Grid item xs={4}>
                  <InputLabel>Max-Length</InputLabel>
                </Grid>
                <Grid item xs={8}>
                  <Field as={TextField} name="max" type="number" fullWidth size="small" />
                </Grid>

                <Grid item xs={4}>
                  <InputLabel>RegExp</InputLabel>
                </Grid>
                <Grid item xs={8}>
                  <Field as={TextField} name="regexp" fullWidth size="small" />
                </Grid>

                <Grid item xs={12}>
                  <FormControlLabel
                    control={<Checkbox checked={formValues.required} onChange={(e) => setFieldValue('required', e.target.checked)} />}
                    label="Required"
                  />
                </Grid>

                <Grid item xs={12}>
                  <FormControlLabel
                    control={<Checkbox checked={formValues.isAuthKey} onChange={(e) => setFieldValue('isAuthKey', e.target.checked)} />}
                    label="IsAuthKey"
                  />
                </Grid>

                <Grid item xs={12}>
                  <FormControlLabel
                    control={<Checkbox name="isSupportFileRequired" checked={formValues.isSupportFileRequired} onChange={handleChange} />}
                    label="Support File Required"
                  />
                </Grid>

                {formValues.isSupportFileRequired && (
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      name="noOfSupportImages"
                      type="number"
                      label="Number of Images"
                      value={formValues.noOfSupportImages}
                      onChange={handleChange}
                      size="small"
                      inputProps={{ min: 1 }}
                      sx={{ mt: 1 }}
                    />
                  </Grid>
                )}

                <Grid item xs={12}>
                  <Box mt={2} display="flex" justifyContent="flex-end">
                    <Button type="submit" size="small" variant="contained">
                      Save
                    </Button>
                  </Box>
                </Grid>
              </Grid>
            </Form>
          )}
        </Formik>
      </Popover>
    </Box>
  );
}
